<template>
  <div class="navbar">
    <div class="collapse-btn" @click="collapseChage">
      <img src="@/assets/img/menu.png" alt="">
    </div>
    <!-- <el-breadcrumb v-if="showbc" class="breadcrumb-container" separator-class="el-icon-arrow-right" style="float: left">
      <el-breadcrumb-item>{{$t('nav.location')}}：</el-breadcrumb-item>
    </el-breadcrumb> -->
    <el-breadcrumb v-if="showbc" class="breadcrumb-container" separator-class="el-icon-arrow-right">
      <!-- :to="item.path" -->
      <el-breadcrumb-item v-for="item in levelList" :key="item.path">{{$t(item.meta.title)}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import bus from "@/components/common/bus";
import commonFun from "@/utils/commonFun";
export default {
  name: "Navbar",
  data() {
    return {
      levelList: [],
      showbc: false
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    // 侧边栏折叠
    collapseChage() {
      this.collapse = !this.collapse;
      bus.$emit("collapse", this.collapse);
    },
    getBreadcrumb() {
      let _app;
      this.$router.options.routes.filter(app => {
        if (app.children) {
          _app = app.children;
        }
      });
      let matched = this.$route.matched.filter(item => item.path);
      const first = matched[0];
      if (
        first &&
        first.path.trim().toLocaleLowerCase() !==
          "/Dashboard".toLocaleLowerCase()
      ) {
        this.showbc = true;
        if (first.name) {
          let path = first.path;
          let name = first.name;
          let _exApp = null;
          _app.filter(exApp => {
            if (exApp.path == path.substring(0, path.lastIndexOf("-")) || exApp.name == name.substring(0, name.lastIndexOf("-"))) {
              _exApp = exApp;
            }
          });
          if (_exApp != null) {
            matched = [
              { path: _exApp.path, meta: { title: _exApp.meta.title } }
            ].concat(matched);
          }
        }
/*        matched = [{ path: "/dashboard", meta: { title: "nav.home" } }].concat(
          matched
        );*/
      } else {
        this.showbc = false;
      }
      this.levelList = matched;
    }
  }
};
</script>
<style lang="scss">
</style>
